import { BaseModel } from '@/models/baseModel'
import { UserModel } from '@/models/user'
import { ProspectModel } from '@/models/prospect'

export class ForumReactionModel extends BaseModel {
  constructor(reactionData = {}) {
    super()
    const { emoji, emojiHtml, count, isOwnReaction, members, isViewed } = reactionData || {}

    this.emoji = emoji
    this.emojiHtml = emojiHtml
    this.count = count || 0
    this.isOwnReaction = isOwnReaction || false
    this.isViewed = isViewed ?? true
    this.members = Array.isArray(members)
      ? members.map((member) => {
          if (member.type === 'user') {
            return {
              type: 'user',
              user: new UserModel(member.user)
            }
          }
          if (member.type === 'prospect') {
            return {
              type: 'prospect',
              prospect: new ProspectModel(member.prospect)
            }
          }
          return member
        })
      : []
  }

  static parseFromApi({ reaction, users, prospects }) {
    const members = reaction?.members
      ?.map((member) => {
        if (member.anonymousId) {
          return {
            anonymousId: member.anonymousId
          }
        }
        if (member.isModerator === true || member.isModerator === false) {
          return {
            isModerator: member.isModerator
          }
        }
        if (member.userId) {
          const user = users?.find((user) => user.id === member.userId)

          if (!user) {
            return null
          }

          return {
            type: 'user',
            user: UserModel.parseFromApi({ user })
          }
        }
        if (member.prospectAccountId) {
          const prospect = prospects?.find((prospect) => prospect.id === member.prospectAccountId)

          if (!prospect) {
            return null
          }

          return {
            type: 'prospect',
            prospect: ProspectModel.parseFromApi({ prospect })
          }
        }
        return null
      })
      .filter((member) => Boolean(member))

    return new ForumReactionModel({
      emoji: reaction?.emoji,
      count: reaction?.count,
      isOwnReaction: reaction?.isOwnReaction,
      isViewed: reaction?.isViewed,
      members: members
    })
  }
}
